import { BREAKPOINTS } from '../../model/model';
import { isIOS, isAndroid, isDefined, isString, not, isNotDefined, anyOf, parseInt10, each, getFileExtension, getUriParams, getObjForPagination } from '../../utils/util';
import { getDatasWithOption } from '../../utils/service';
import * as util from "../../utils/util";

class PowerbookMain {
    constructor(options) {
        const _ = this;

        // variables
        _.option = $.extend({
            wrap: null,
            apiDomain: '',
            global: window
        }, options);

        _.data = null;

        _.global = (_.option.global) ? _.option.global : window;

        _.wrap = null;
        _.msg = {
            FAIL_LOAD_DATA: '데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        };
    }

    /*
     * public methods
     */
    init() {
        const _ = this;
        _.wrap = _.option.wrap;

        console.log('# powrbook-main.js _.option.apiDomain: ', _.option.apiDomain);

        getDatasWithOption([{
            type: 'GET',
            url: _.option.apiDomain +'/conti/getContent?service=lineage&alias=powerbook&lang=ko-KR',
            dataType: 'json',
            contentType: 'application/json',
            Accept: 'application/json'
        }], (data) => {
            console.log('# powrbook-main.js data : ', JSON.parse(data.jsonData) );
            if(data.jsonData.length <= 0) {
                _.setNoData();
            } else {
                _.setData(JSON.parse(data.jsonData));
            }
        }, (data) => {
            console.log(_.msg.FAIL_LOAD_DATA); // _.global.alert(_.msg.FAIL_LOAD_DATA); // '데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.'
        });
        return _;
    }

    setNoData() {
        const _wrap = $(this.wrap[0]);
        _wrap.empty().append(`<div class="nodata"> - </div>`);
    }

    setData(data) {

        const _ = this;
        let _todayTmpl = `
        ${data.today.map((item, index) => {
            return `
            <div class="recommend__bundle">
				<h3 class="recommend__bundle-tit">${item.title}</h3>
				<ul class="recommend__bundle-list">
				    ${item.items.map((it, idx) => {
				        return `
				        <li class="recommend__item">
                            <a href="${it.url}">
                                <div class="pic-box pic-box_theme_full">
                                    <img class="pic-box__img" src="${it.thumbnailSrc}" alt="">
                                    <span class="pic-box__text">${it.title}</span>
                                </div>
                                <span class="recommend__item-desc">${it.desc}</span>
                            </a>
                        </li>
				        `;
                    }).join('')}
				</ul>
			</div>
            `;
        }).join('')}
        `;
        const todayWrap = $(this.wrap[0]);
        todayWrap.empty().append(_todayTmpl);

        let _indexTmpl = `
        ${data.index.map((indexItem, indexIndex) => {
            return `
            <div class="guide__item">
				<h3 class="guide__item-tit">${indexItem.title}</h3>
				<ul class="guide__item-list">
				    ${indexItem.items.map((indexIt, indexIdx) => {
                    return `
				        <li><a href="${indexIt.desc}">${indexIt.title} ${indexIt.new ? `<i class="icon-new"></i>`:``}</a></li>
				        `;
            }).join('')}
				</ul>
			</div>
            `;
        }).join('')}
        `;

        const indexWrap = $(this.wrap[1]);
        indexWrap.empty().append(_indexTmpl);

        _.setEvent();
    }
    setEvent() {
        // console.log('setEvent init');

        let guideSlickActive        = false;
        let DOM_guideList           = $('.guide__list');
        let DOM_recommendList       = $('.recommend__list');
        let DOM_recommendBundle     = $('.recommend__bundle');
        let DOM_recommendController = $('.recommend__controller');

        function fnTodayTable() {
            if(DOM_recommendBundle.length > 1){
                DOM_recommendList.slick({
                    arrows: false,
                    speed: 250,
                    useTransform: true,
                    dots: true,
                    infinite: true,
                    cssEase: 'cubic-bezier(0.1, 0.54, 0.4, 1)'
                });

                DOM_recommendController.on('click', '.recommend__controller-prev', function(){
                    DOM_recommendList.slick('slickPrev');
                });

                DOM_recommendController.on('click', '.recommend__controller-next', function(){
                    DOM_recommendList.slick('slickNext');
                });
            } else {
                DOM_recommendController.hide();
            }
        }

        function fnIndexTable() {
            if(util.getResolution() === 'phone'){
                if(guideSlickActive === false){
                    DOM_guideList.slick({
                        centerMode: true,
                        centerPadding: '18px',
                        arrows: false,
                        infinite: false,
                        speed: 200,
                        useTransform: true,
                        cssEase: 'cubic-bezier(0.1, 0.54, 0.4, 1)'
                    });
                    guideSlickActive = true;
                }
            } else {
                if(guideSlickActive === true){
                    DOM_guideList.slick('unslick');
                    guideSlickActive = false;
                }
            }
        }


        fnTodayTable();
        fnIndexTable();

        $(window).on('resize', () =>{
            fnIndexTable();
        });

    }

}

export default PowerbookMain;


// WEBPACK FOOTER //
// ./_src/js/powerbook/main/PowerbookMain.js